import Pagination from "react-bootstrap/Pagination";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function PaginationButtons(props: any) {

  const maxPages = getMaxPages();

  let pages = [];
  for (let i = 1; i <= maxPages; i++) {
    let obj = <option key={"o" + i}>{i}</option>;
    pages.push(obj);
  }


  const pageSizes = [25, 50, 100, 150, 200].map( s => <option key={"ps" + s.toString()}>{s}</option>);
  const numberFormat = new Intl.NumberFormat();

  //****************************************************************
  //component functions

  function getMaxPages(): number {
    let maxPages = Math.floor(parseInt(props.size) / parseInt(props.pageSize));
    let difference = props.size % props.pageSize;
    if (difference > 0) {
      maxPages++;
    }
    return maxPages;
  }

  function nextPage() {
    let maxPages = getMaxPages();
    let next = props.actualPage + 1;
    if (next <= maxPages) {
      props.setActualPage(next);
    }
  }

  function previousPage() {
    let prev = props.actualPage - 1;
    if (prev > 0) {
      props.setActualPage(prev);
    }
  }

  function pageChanged(e: any) {
    props.setActualPage(parseInt(e.target.value));
  }

  function pageSizeChanged(e: any) {
    
    try {
      window.localStorage.setItem("apptap.dashboard.pageSize",e.target.value);
    } catch (error) {
      console.log(error);
    }
    
    props.setPageSize(parseInt(e.target.value));
    props.setActualPage(1);
  }

  function changePage(value: any) {
    props.setActualPage(value);
  }

  let paginationPanel :any = null;
  if ( maxPages !== 1) {
    paginationPanel = 
      (
        <Col xl={3}>
          <Pagination size="sm" className=".align-top">
            <Pagination.First onClick={(e) => changePage(1)}>First</Pagination.First>
            <Pagination.Prev onClick={previousPage}>Previous</Pagination.Prev>
            <Form.Group controlId="exampleForm.ControlSelect1">
              <Form.Control as="select" size="sm" onChange={pageChanged}  key="ControlSelect1" value={props.actualPage}>
                {pages}
              </Form.Control>
            </Form.Group>
            <Pagination.Next onClick={nextPage}>Next</Pagination.Next>
            <Pagination.Last onClick={(e) => changePage(maxPages)}>Last</Pagination.Last>
          </Pagination>
        </Col>    
      );
  }
  else {
    paginationPanel = ( <Col xl={3}></Col>);
  }


  return (
    <Row>
      <Col xl={1}> </Col>
      <Col xl={3}>
        <Form.Group as={Row} controlId="formPlaintextEmail">
          <Form.Label column sm="12">
          Page: {numberFormat.format(props.actualPage)} of {numberFormat.format(maxPages)}. Rows returned: {numberFormat.format(props.size)}
          </Form.Label>
        </Form.Group>
      </Col>
      <Col xs="auto">
        <Form.Group size="sm" as={Row} controlId="frmPageSize">
          <Form.Label  column sm="12" key="frmPageSize">
            Page size
          </Form.Label>
        </Form.Group>
      </Col>
      <Col xs="auto">
        <Form.Group size="sm" as={Row} controlId="frmCmb">
          <Col sm="12">
            <Form.Control as="select" size="sm" onChange={pageSizeChanged} value={props.pageSize} key="frmCmb">
                {pageSizes}
            </Form.Control>
          </Col>
        </Form.Group>
      </Col>      
      {paginationPanel}
      <Col xl={3}> </Col>
    </Row>
  );
}

export default PaginationButtons;
